import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';
import { useConfig, listOptions } from '../../../context/ConfigContext';

// TS port of the source (Falah) app's pages/reports/revenue/InvoiceRegisterReport.jsx.
const STATUS_OPTIONS: ReportOption[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'issued', label: 'Issued' },
  { value: 'sent', label: 'Sent' },
  { value: 'partially_paid', label: 'Partially Paid' },
  { value: 'paid', label: 'Paid' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'cancelled', label: 'Cancelled' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'invoice_number', label: 'Invoice #' },
  { key: 'customer_name', label: 'Customer' },
  { key: 'type', label: 'Type' },
  { key: 'category', label: 'Category' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'invoice_date', label: 'Invoice Date' },
  { key: 'due_date', label: 'Due Date' },
  { key: 'status', label: 'Status' },
  { key: 'paid', label: 'Paid', align: 'right', type: 'money' },
  { key: 'balance', label: 'Balance', align: 'right', type: 'money' },
];

export function InvoiceRegisterReport() {
  const { lists } = useConfig();

  return (
    <ReportView
      title="Invoice Register & Aging"
      description="Customer invoices with amount, paid, and outstanding balance."
      endpoint="/reports/revenue/invoice-register"
      columns={COLUMNS}
      filters={['status', 'category', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
      categoryOptions={listOptions(lists, 'invoice_type')}
    />
  );
}
